import * as _ from 'underscore';
import { Component, OnInit } from '@angular/core';
import { EVENT_EXPORT_REPORT } from '../../../../shared/app-events';
import { GaEventService } from '../../../../shared/services/ga-event.service';
import { BaseDashboardHeaderComponent } from './base-dashboard-header.component';
import { IDashboardExportMetadata } from '../dashboard-metadata.service';

@Component({
  selector: 'order-dashboard-header',
  template: `
    <div class="dashboard-header dashboard-comments">
      Download open items<br/>
      <ng-container *ngFor="let items of downloadItems; let i = index; trackById">
        - <a href="" (click)="onClick($event, items)">{{ labels[i] }}</a><br/>
      </ng-container>
      Upload open items<br/>
      - <a href="/ga2/#/unacc?url=%2Funacc%2FImportOrdDataView_Edit.jsp%3FDeimpty%3DORDDATA%26ejbEvent%3Dcreate%26useCase%3DUPLOAD_BP_OPEN_ITEMS%26useCase%3DUPLOAD_BP_OPEN_ITEMS%26wv_Detitle%3DUpload%2520BP%2520open%2520items" target="_blank">order level</a><br/>
      - <a href="/ga2/#/unacc?url=%2Funacc%2FReqData_Edit.jsp%3FDeimpty%3DREQDATA%26ejbEvent%3Dcreate%26UplSerial%3D1%26wv_Detitle%3DUpload%2520asset%2520data%2520with%2520ACSL%2523" target="_blank">asset level</a><br/>
      - <a href="/ga2/#/unacc?url=%2Funacc%2FImportOrdDataView_Edit.jsp%3FDeimpty%3DORDDATA%26ejbEvent%3Dcreate%26useCase%3DUPLOAD_BP_INVOICES%26useCase%3DUPLOAD_BP_INVOICES%26wv_Detitle%3DUpload%2520BP%2520invoice%2520data" target="_blank">missing invoices</a>
    </div>
  `
})
export class OrderDashboardHeaderComponent extends BaseDashboardHeaderComponent implements OnInit {
  public downloadItems:IDashboardExportMetadata[];
  public labels:string[] = ['order level', 'asset level', 'missing invoices'];

  constructor(
    private eventService:GaEventService
  ) {
    super();
  }

  public ngOnInit():void {
    this.downloadItems = _.clone(this.dashboardMetadata?.export?.reports);
    this.downloadItems.pop();
  }
  
  public onClick(e:Event, report):void {
    e.preventDefault();
    this.eventService.sendMessage(EVENT_EXPORT_REPORT, report);
  }
}